export const TOKEN_KEY = "huozhewang_token";
export const USERINFO_KEY = "huozhewang_userInfo";
